//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'ProfileProgress',

	computed: {
		progressText() {
			if (this.percent >= 100) return this.$t('your_profile_is_complete');

			if (this.percent > 75)
				return this.$t('your_profile_is_almost_complete');

			return this.$t('please_complete_your_profile');
		},
	},

	methods: {
		goToPage(path) {
			this.$emit('progress-step-selected');

			this.$router.push(path);
		},
	},
};
